import React, { useState, useEffect, ReactElement, memo, FC } from 'react';
import Lottie, { LottieComponentProps } from 'lottie-react';
import { animationToCdn, fetchAndCacheAnimation } from '../../utils/images';
import { Animation } from '../../resources/images';
import { useTheme } from '@mui/material/styles';

interface LCAnimationProps {
    animation: Animation;
    lottieProps?: Partial<LottieComponentProps>;
    roundedBackground?: boolean;
}

const LCAnimation: FC<LCAnimationProps> = ({ animation, lottieProps, roundedBackground }): ReactElement => {
    const theme = useTheme();
    const { mode } = theme.palette;
    const [animationData, setAnimationData] = useState<any>(null);

    const customStyle: any = { width: 40, height: 40 };

    if (roundedBackground) {
        customStyle.padding = 5;
        customStyle.borderRadius = 8;
        customStyle.backgroundColor = theme.palette.colors.border;
    }

    useEffect(() => {
        const loadAnimation = async () => {
            const url = animationToCdn(animation, mode === 'dark');
            try {
                const data = await fetchAndCacheAnimation(url);
                setAnimationData(data);
            } catch (error) {
                console.error('Error loading animation:', error);
            }
        };

        loadAnimation();
    }, [animation, mode]);

    if (!animationData) {
        return <div style={customStyle} />;
    }

    return <Lottie animationData={animationData} {...lottieProps} style={customStyle} />;
};

export default memo(LCAnimation);
